function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.16406 10.1954L2.58281 4.69223C4.81406 1.91723 8.16094 0.389103 11.5828 0.375041C13.5656 0.360978 15.5906 0.867228 17.4328 1.93129C19.4672 3.11254 21.0141 4.80942 21.9984 6.75942L12.375 6.25317C9.65156 6.09379 7.05937 7.6266 6.16406 10.1954ZM7.70625 12C7.70625 14.1657 9.45938 15.9188 11.625 15.9188C13.7906 15.9188 15.5438 14.1657 15.5438 12C15.5438 9.83442 13.7906 8.08129 11.625 8.08129C9.45938 8.08129 7.70625 9.82973 7.70625 12ZM22.4672 7.81879L15.9188 8.15629C17.6953 10.2329 17.7234 13.2282 16.2281 15.525L10.9734 23.6063C13.1531 23.7235 15.3984 23.2454 17.4328 22.0641C22.4672 19.1579 24.5062 13.0641 22.4672 7.81879ZM6.26719 14.2313L1.89375 5.62973C0.698438 7.45785 0 9.6516 0 12C0 17.8125 4.25625 22.6266 9.82031 23.4797L12.8063 17.6297C10.1063 18.136 7.5 16.6547 6.26719 14.2313Z",
  fill: "white"
});

var SvgChrome = function SvgChrome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChrome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chrome.e2366c8e.svg";
export { ForwardRef as ReactComponent };